// istanbul ignore file

import * as yup from '@cld/yup-extra';

import { cookbookRecipeCategorySchema } from './CookbookRecipeCategory';
import { CookbookRecipeComplexity } from './CookbookRecipeComplexity';

export type RecipeType = 'image' | 'video';

export const cookbookRecipeDtoSchema = yup
  .object({
    categories: yup.array(cookbookRecipeCategorySchema).required(),
    complexity: yup.mixed<CookbookRecipeComplexity>().oneOf(['beginner', 'intermediate', 'advanced']).required(),
    content: yup.string().required(),
    excerpt: yup.string().required(),
    id: yup.number().required(),
    thumbnailUrl: yup.string().required(),
    title: yup.string().required(),
    slug: yup.string().required(),
    type: yup.mixed<RecipeType>().oneOf(['image', 'video']).required(),
    recipeUrl: yup.string().required(),
    recipeResourcesIds: yup.array().of(yup.string().required()).required(),
    recipeUrlTransformationString: yup.string().required(),
  })
  .required();

export type CookbookRecipeDto = Awaited<ReturnType<(typeof cookbookRecipeDtoSchema)['validate']>>;
